import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
const HomeView = () => import('./views/HomeView.vue')
const LoginView = () => import('./views/LoginView.vue')
const RegisterView = () => import('./views/RegisterView.vue')
const ForgotPasswordView = () => import('./views/ForgotPasswordView.vue')
const PasswordResetView = () => import('./views/PasswordResetView.vue')
const DashboardView = () => import('./views/DashboardView.vue')
const BiomarkerView = () => import('./views/BiomarkerView.vue')
const TimelineView = () => import('./views/TimelineView.vue')
const AddLabReportView = () => import('./views/AddLabReportView.vue')
const EditLabReportView = () => import('./views/EditLabReportView.vue')
const SettingsView = () => import('./views/SettingsView.vue')
const SecurityView = () => import('./views/SecurityView.vue')
const BillingView = () => import('./views/BillingView.vue')
const BiomarkerListAdminView = () =>
  import('./views/BiomarkerListAdminView.vue')
const BiomarkerAddView = () => import('./views/BiomarkerAddView.vue')
const BiomarkerEditView = () => import('./views/BiomarkerEditView.vue')
const NotFoundView = () => import('./views/NotFoundView.vue')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'LoginView',
      component: LoginView,
      meta: { guestOnly: true }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPasswordView',
      component: ForgotPasswordView
    },
    {
      path: '/password-reset/:token',
      name: 'PasswordResetView',
      component: PasswordResetView
    },
    {
      path: '/register/:plan?',
      name: 'RegisterView',
      component: RegisterView,
      meta: { guestOnly: true }
    },
    {
      path: '/dashboard',
      name: 'DashboardView',
      component: DashboardView,
      meta: { requiresAuth: true }
    },
    {
      path: '/marker/:id',
      name: 'BiomarkerView',
      component: BiomarkerView,
      meta: { requiresAuth: true }
    },
    {
      path: '/timeline',
      name: 'TimelineView',
      component: TimelineView,
      meta: { requiresAuth: true }
    },
    {
      path: '/lab-reports/add',
      name: 'AddLabReportView',
      component: AddLabReportView,
      meta: { requiresAuth: true }
    },
    {
      path: '/lab-reports/:id/edit',
      name: 'EditLabReportView',
      component: EditLabReportView,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings',
      name: 'SettingsView',
      component: SettingsView,
      meta: { requiresAuth: true }
    },
    {
      path: '/billing',
      name: 'BillingView',
      component: BillingView,
      meta: { requiresAuth: true }
    },
    {
      path: '/security',
      name: 'SecurityView',
      component: SecurityView,
      meta: { requiresAuth: true }
    },
    {
      path: '/biomarker-list',
      name: 'BiomarkerListAdminView',
      component: BiomarkerListAdminView,
      meta: { requiresAdmin: true, requiresAuth: true }
    },
    {
      path: '/biomarker/add',
      name: 'BiomarkerAddView',
      component: BiomarkerAddView,
      meta: { requiresAdmin: true, requiresAuth: true }
    },
    {
      path: '/biomarker/:id/edit',
      name: 'BiomarkerEditView',
      component: BiomarkerEditView,
      meta: { requiresAdmin: true, requiresAuth: true }
    },
    {
      path: '/not-found',
      name: 'NotFoundView',
      component: NotFoundView
    },
    {
      path: '*', // or '/index.html'
      beforeEnter: (to, from, next) => {
        next('/')
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isUserLoggedIn
  const isAdmin = store.getters.isAdmin
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    return !isAdmin
      ? next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      : next()
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    return !isLoggedIn
      ? next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      : next()
  }
  if (to.matched.some(record => record.meta.guestOnly)) {
    return isLoggedIn ? next('/dashboard') : next()
  }
  if (!to.matched.length) {
    return next('/not-found')
  }
  return next()
})

export default router
